import { useContext } from "react";
import { useOutletContext } from "react-router-dom";

import { CartContext } from "../context/CartContext";
import { UserContext } from "../context/UserContext";

import getImgUrl from "../helper/getImgUrl";
import CurrencyDisplay from "../components/CurrencyDisplay"

import styles from "../styles/checkout.module.css"

const Checkout = () => {
    const { cartItem, cartTotal, taxes, checkoutUrl } = useContext(CartContext);
    const { handleAccountClick } = useOutletContext();
    const { user } = useContext(UserContext);

    const handleOrder = (e) => {
        e.preventDefault();
        if (checkoutUrl) window.location.href = checkoutUrl;
    };

    return (
        <div className={styles.maincheckout}>
            <div className={styles.leftside}>
                <form id="orderform" onSubmit={handleOrder}>
                    {user === null ? (
                        <div className={styles.formcontainer}>
                            <p>If you already have an account please <span onClick={handleAccountClick}>login here</span></p>
                            <div className={styles.labelform}>
                                <h3>Contact info</h3>
                            </div>

                            <div className={styles.createAccount}>
                                <input type="text" placeholder="First name" />
                                <input type="text" placeholder="Last name" />
                                <input type="email" placeholder="Email" />
                                <input type="password" placeholder="password" />
                                <input type="password" placeholder="Confirm password" />
                            </div>
                            <div className={styles.labelform}>
                                <h3>Shipping</h3>
                            </div>

                            <div className={styles.billingUser}>
                                <input type="text" placeholder="Address" />
                                <input type="text" placeholder="Billing address" />
                            </div>

                            <div className={styles.labelform}>
                                <h3>Payment method</h3>
                            </div>
                            <div className={styles.method}>
                                <input type="radio" name="payment_method" id="e-transfer" value="E-transfer" />
                                <label htmlFor="e-transfer">E-transfer</label>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.loggedUser}>
                            <div>
                                <div className={styles.userWelcome}>
                                    <h2>Hey, {user.first_name}! Welcome back</h2>
                                    <p>Please confirm your shipping and billing information below before submitting your order</p>
                                </div>
                            </div>
                            <div className={styles.labelform}>
                                <h3>Shipping</h3>
                            </div>

                            <div className={styles.billingUser}>
                                <input type="text" placeholder="Address" defaultValue={user.address || ''} />
                                <input type="text" placeholder="Billing address" />
                            </div>

                            <div className={styles.labelform}>
                                <h3>Payment method</h3>
                            </div>
                            <div className={styles.method}>
                                <input type="radio" name="payment_method" id="e-transfer" value="E-transfer" />
                                <label htmlFor="e-transfer">E-transfer</label>
                            </div>
                        </div>
                    )}
                </form>
            </div>

            <div className={styles.rightside}>
                <div className={styles.items}>
                    {Array.isArray(cartItem) && cartItem.map(item => (
                        <div className={styles.itemcontainer} key={item.cart_item_id}>
                            <div className={styles.maininfo}>
                                <div className={styles.imgcontainer}>
                                    <img src={getImgUrl(item.images?.[0], 'product')} alt=''/>
                                </div>
                                <div className={styles.cartinfo}>
                                    <p>{item.title}</p>
                                    <p>{item.material}</p>
                                    <div className={styles.quantitybtn}>
                                        <p>{item.quantity}</p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightinfo}>
                                <CurrencyDisplay amount={item.price} currency='CAD' />
                            </div>
                        </div>
                    ))}
                </div>
                <div className={styles.total}>
                    <div className={styles.subtotal}>
                        <div>
                            <p><span>Subtotal:</span></p>
                            <p><span>Shipping:</span></p>
                            <p><span>Taxes:</span></p>
                        </div>
                        <div>
                            <p><CurrencyDisplay amount={cartTotal} currency='CAD'/></p>
                            <p><CurrencyDisplay amount={0} currency='CAD'/></p>
                            <p><CurrencyDisplay amount={taxes} currency='CAD'/></p>
                        </div>
                    </div>
                    <div className={styles.includedin}>
                        <div className={styles.topcontainer}>
                            <div>
                                <p>Total:</p>
                            </div>
                            <div>
                                <CurrencyDisplay amount={cartTotal + taxes} currency='CAD'/>
                            </div>
                        </div>
                        <div className={styles.production}>
                            <p>Production</p>
                            <p>8 to 10 weeks for Custom fixtures – 1 to 2 weeks for the Quick Ship Collection</p>
                        </div>
                        <button className={styles.submitbtn} type="submit" form="orderform">Submit order</button>
                    </div>
                </div>
            </div>

        </div>
    )
};

export default Checkout;
